import React, { useId, useMemo } from "react";
import { useCrown, CROWN_TITLES, leadsAny } from "@/lib/crowns";
import { crownSvg } from "@/lib/crownSvg";

// The sparkling gold crown floating over a leaderboard #1's raider, for the
// one category (`category`: "jangle", "race", "live", or a list of them) it's shown in. Renders
// nothing for anyone else. `className` sizes and places it.
export default function LeaderCrown({ userId, category, className = "w-4", style, testId }) {
  const leads = useCrown(userId);
  const id = useId().replace(/:/g, "");
  const svg = useMemo(() => crownSvg(id), [id]);
  const led = leadsAny(leads, category);
  if (!led) return null;
  const title = `Number 1 on the ${CROWN_TITLES[led] || led} leaderboard`;
  return (
    <span className={`leader-crown inline-block align-middle ${className}`} title={title}
      role="img" aria-label={title} data-testid={testId || "leader-crown"} style={style}
      dangerouslySetInnerHTML={{ __html: svg }} />
  );
}
